import {makeStyles} from "tss-react/mui";

export const usePowerbarStyles = makeStyles()((theme) => ({
  powerbar: {
    "&>.MuiDialog-container": {
      height: "unset",
    },
  },
}));
